import React, { FunctionComponent, PropsWithChildren } from 'react';

import { Main } from '@vwfs-bronson/bronson-react';
import { useSelector } from 'react-redux';
import { PasswordUpcomingExpirationNotification } from '..';
import { getIsPasswordCloseToExpiration } from '../../services/redux/features/auth.slice';
import { Page } from '../../types/footer';
import { Footer } from '../Layout/Footer';
import { AppHeader } from '../Layout/AppHeader';
import { BaseHeader } from '../Layout/BaseHeader';
import { HeaderItem, useHeaderItems } from '../Layout/useHeaderItems';

export type DefaultLayoutProps = {
  pages: Page[];
};

export const DefaultLayout: FunctionComponent<PropsWithChildren<DefaultLayoutProps>> = ({ children, pages }) => {
  const isPasswordCloseToExpiration = useSelector(getIsPasswordCloseToExpiration);
  const visibleItems: HeaderItem[] | null = useHeaderItems();

  const shouldRenderNavigation = visibleItems !== null;

  return (
    <>
      {isPasswordCloseToExpiration && <PasswordUpcomingExpirationNotification />}

      {shouldRenderNavigation ? <AppHeader visibleItems={visibleItems} /> : <BaseHeader navigation={null} />}
      <Main>{children}</Main>
      <Footer pages={pages} />
    </>
  );
};
